import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '@/api/api';
import { ENDPOINT } from '@/constants/endpoints';
import { Scope } from '@/types/common';
import { OverviewResponse } from '@/types/overview';

type OverviewQueryParams = {
  scope: Scope;
};

export const overviewApi = createApi({
  reducerPath: 'overviewApi',
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    getOverview: builder.query<OverviewResponse, OverviewQueryParams>({
      query: params => ({
        url: ENDPOINT.OVERVIEW.GET_ALL(),
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useGetOverviewQuery } = overviewApi;
